// hooks/useScrollRestoration.js
import { useEffect } from 'react';
import { useRouter } from 'next/router';

export default function useScrollRestoration() {
    const router = useRouter();
    const positions = {};

    useEffect(() => {
        if (!('scrollRestoration' in window.history)) return;

        let shouldScrollRestore = false;
        window.history.scrollRestoration = 'manual';

        const saveScroll = (url) => {
            positions[url] = window.scrollY;
        };

        const restoreScroll = (url) => {
            const y = positions[url] || 0;
            window.scrollTo(0, y);
        };

        const onBeforeUnload = () => {
            saveScroll(router.asPath);
        };

        const onRouteChangeStart = (url) => {
            saveScroll(router.asPath);
        };

        const onRouteChangeComplete = (url) => {
            if (shouldScrollRestore) {
                shouldScrollRestore = false;
                restoreScroll(url);
            } else {
                window.scrollTo(0, 0);
            }
        };

        const onPopState = () => {
            shouldScrollRestore = true;
        };

        window.addEventListener('beforeunload', onBeforeUnload);
        window.addEventListener('popstate', onPopState);
        router.events.on('routeChangeStart', onRouteChangeStart);
        router.events.on('routeChangeComplete', onRouteChangeComplete);

        return () => {
            window.removeEventListener('beforeunload', onBeforeUnload);
            window.removeEventListener('popstate', onPopState);
            router.events.off('routeChangeStart', onRouteChangeStart);
            router.events.off('routeChangeComplete', onRouteChangeComplete);
        };
    }, [router]);
}
